/* ==========================================================================
   MOBILE BARCODE SCANNER
   Fullscreen camera scanner with intro sheet, gallery upload, manual entry.
   Loads html5-qrcode from CDN for camera scanning and jsQR for gallery decode.
   ========================================================================== */
   (function () {
    'use strict';
  
    var CDN_HTML5_QRCODE = 'https://cdn.jsdelivr.net/npm/html5-qrcode@2.3.8/html5-qrcode.min.js';
    var MOBILE_MQ = '(max-width: 699px)';
  
    var ANIM_CYCLE = 3200;
    var INTRO_TITLES = [
      'Tilt your phone left',
      'Align barcode in frame',
      'Scans instantly'
    ];
    var INTRO_SUBS = [
      'Rotate anti-clockwise until the barcode on the tag sits flat in the frame',
      'Hold still once the tag is horizontal — it reads in under a second',
      'Product page opens automatically — no tap needed'
    ];
  
    /* ── Helpers ── */
  
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + src + '"]');
        if (existing) { resolve(); return; }
        var s = document.createElement('script');
        s.src = src;
        s.defer = true;
        s.onload = resolve;
        s.onerror = function () { reject(new Error('Failed to load ' + src)); };
        document.head.appendChild(s);
      });
    }
  
    function isMobile() {
      return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
    }
  
    function closeMegaMenu() {
      var mm = document.getElementById('ch-mega-menu');
      if (mm && mm.classList.contains('is-open')) {
        mm.classList.remove('is-open');
        mm.setAttribute('aria-hidden', 'true');
        var overlay = document.getElementById('ch-overlay');
        if (overlay) overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        document.querySelectorAll('[aria-controls="ch-mega-menu"]').forEach(function (el) {
          el.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.ch-bottom-nav__item--mega-open').forEach(function (el) {
          el.classList.remove('ch-bottom-nav__item--mega-open');
        });
      }
    }
  
    /* ── Constructor ── */
  
    function MobileBarcodeScanner(modal) {
      this.modal = modal;
      this.rootUrl = (modal.getAttribute('data-root-url') || '/').replace(/\/$/, '') || '';
  
      this.intro        = modal.querySelector('[data-barcode-intro]');
      this.introCta     = modal.querySelector('[data-barcode-intro-continue]');
      this.introClose   = modal.querySelector('[data-barcode-intro-close]');
      this.introHeading = modal.querySelector('[data-barcode-intro-heading]');
      this.introText    = modal.querySelector('[data-barcode-intro-text]');
      this.viewport     = modal.querySelector('[data-barcode-viewport]');
      this.status       = modal.querySelector('[data-barcode-status]');
      this.bottomMsg    = modal.querySelector('[data-barcode-bottom-msg]');
      this.closeBtn     = modal.querySelector('[data-barcode-close]');
      this.flashBtn     = modal.querySelector('[data-barcode-flash]');
      this.galleryBtn     = modal.querySelector('[data-barcode-gallery]');
      this.galleryInput   = modal.querySelector('[data-barcode-gallery-input]');
      this.galleryPreview = modal.querySelector('[data-barcode-gallery-preview]');
      this.galleryImg     = modal.querySelector('[data-barcode-gallery-img]');
      this.galleryViewport = modal.querySelector('[data-barcode-gallery-viewport]');
      this.galleryScanBtn = modal.querySelector('[data-barcode-gallery-scan]');
      this.galleryCancelBtn = modal.querySelector('[data-barcode-gallery-cancel]');
      this.galleryHint    = modal.querySelector('[data-barcode-gallery-hint]');
      this.zoomInBtn      = modal.querySelector('[data-barcode-zoom-in]');
      this.zoomOutBtn     = modal.querySelector('[data-barcode-zoom-out]');
      this.zoomResetBtn   = modal.querySelector('[data-barcode-zoom-reset]');
      this._galleryFile   = null;
      this.manualTrigger = modal.querySelector('[data-barcode-manual-trigger]');
      this.manualOverlay = modal.querySelector('[data-barcode-manual-overlay]');
      this.manualClose   = modal.querySelector('[data-barcode-manual-close]');
      this.manualForm    = modal.querySelector('[data-barcode-manual-form]');
      this.manualInput   = modal.querySelector('[data-barcode-manual-input]');
      this.manualStatus  = modal.querySelector('[data-barcode-manual-status]');
  
      this.scanner = null;
      this.scanning = false;
      this.flashOn = false;
      this._introAnimRunning = false;
      this._resetPinchZoom = function () {};
      this._zoomBy = function () {};
      this._getZoomState = function () { return { scale: 1, posX: 0, posY: 0 }; };
      this.hasSeenIntro = false;
  
      this._bind();
    }
  
    MobileBarcodeScanner.prototype._bind = function () {
      var self = this;
  
      if (this.introCta) {
        this.introCta.addEventListener('click', function () { self._dismissIntro(); });
      }
  
      if (this.introClose) {
        this.introClose.addEventListener('click', function () { self.close(); });
      }
  
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function () { self.close(); });
      }
  
      if (this.flashBtn) {
        this.flashBtn.addEventListener('click', function () { self._toggleFlash(); });
      }
  
      if (this.galleryBtn && this.galleryInput) {
        this.galleryBtn.addEventListener('click', function () { self.galleryInput.click(); });
        this.galleryInput.addEventListener('change', function (e) { self._handleGallerySelect(e); });
      }
  
      if (this.galleryScanBtn) {
        this.galleryScanBtn.addEventListener('click', function () { self._scanGalleryImage(); });
      }
  
      if (this.galleryCancelBtn) {
        this.galleryCancelBtn.addEventListener('click', function () { self._hideGalleryPreview(); });
      }
  
      if (this.galleryViewport) {
        self._initPinchZoom();
      }
  
      if (this.zoomInBtn) {
        this.zoomInBtn.addEventListener('click', function () { self._zoomBy(0.5); });
      }
      if (this.zoomOutBtn) {
        this.zoomOutBtn.addEventListener('click', function () { self._zoomBy(-0.5); });
      }
      if (this.zoomResetBtn) {
        this.zoomResetBtn.addEventListener('click', function () { self._resetPinchZoom(); });
      }
  
      if (this.manualTrigger && this.manualOverlay) {
        this.manualTrigger.addEventListener('click', function () { self._showManual(); });
      }
  
      if (this.manualClose) {
        this.manualClose.addEventListener('click', function () { self._hideManual(); });
      }
  
      if (this.manualForm) {
        this.manualForm.addEventListener('submit', function (e) {
          e.preventDefault();
          self._submitManual();
        });
      }
  
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.modal.hidden) {
          self.close();
        }
      });
    };
  
    /* ── Open / Close ── */
  
    MobileBarcodeScanner.prototype.open = function () {
      if (!isMobile()) return;
  
      closeMegaMenu();
  
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
  
      if (!this.hasSeenIntro) {
        this._showIntro();
      } else {
        this._startCamera();
      }
    };
  
    MobileBarcodeScanner.prototype.close = function () {
      this._stopCamera();
      this._hideManual();
      this._hideIntro();
      this.modal.hidden = true;
      this.modal.classList.remove('barcode-scanner--intro');
      document.body.style.overflow = '';
    };
  
    /* ── Intro ── */
  
    MobileBarcodeScanner.prototype._showIntro = function () {
      if (!this.intro) { this._startCamera(); return; }
      this.intro.hidden = false;
      this.modal.classList.add('barcode-scanner--intro');
  
      var self = this;
      this._introAnimRunning = true;
  
      function tick() {
        if (!self._introAnimRunning) return;
        var t = (Date.now() % ANIM_CYCLE) / ANIM_CYCLE;
        var i = t < 0.38 ? 0 : t < 0.68 ? 1 : 2;
        if (self.introHeading) self.introHeading.textContent = INTRO_TITLES[i];
        if (self.introText) self.introText.textContent = INTRO_SUBS[i];
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    };
  
    MobileBarcodeScanner.prototype._hideIntro = function () {
      if (this.intro) this.intro.hidden = true;
      this._introAnimRunning = false;
    };
  
    MobileBarcodeScanner.prototype._dismissIntro = function () {
      this.hasSeenIntro = true;
      this._hideIntro();
      this.modal.classList.remove('barcode-scanner--intro');
      this._startCamera();
    };
  
    /* ── Camera ── */
  
    MobileBarcodeScanner.prototype._startCamera = function () {
      var self = this;
  
      this._setStatus('Loading scanner…', '');
  
      loadScript(CDN_HTML5_QRCODE)
        .then(function () {
          if (self.scanning) return;
          if (!self.viewport) return;
  
          var viewportId = self.viewport.id;
          if (!viewportId) {
            viewportId = 'bs-viewport-' + Math.random().toString(36).substr(2, 6);
            self.viewport.id = viewportId;
          }
  
          self.scanner = new Html5Qrcode(viewportId);
          self.scanning = true;
  
          return self.scanner.start(
            { facingMode: 'environment' },
            {
              fps: 10,
              qrbox: { width: 240, height: 160 },
              aspectRatio: 1.0,
              disableFlip: false
            },
            function (decodedText) { self._onScanSuccess(decodedText); },
            function () { /* ignore per-frame scan misses */ }
          );
        })
        .then(function () {
          self._setStatus('Scan it horizontally and try to zoom', '');
        })
        .catch(function (err) {
          console.error('[BarcodeScanner] Camera error:', err);
          var msg = 'Camera access denied or unavailable.';
          if (err && err.message && err.message.indexOf('Permission') !== -1) {
            msg = 'Please allow camera access and try again.';
          }
          self._setStatus(msg, 'error');
        });
    };
  
    MobileBarcodeScanner.prototype._stopCamera = function () {
      if (this.scanner && this.scanning) {
        try { this.scanner.stop(); } catch (e) { /* ignore */ }
        try { this.scanner.clear(); } catch (e) { /* ignore */ }
      }
      this.scanner = null;
      this.scanning = false;
      this.flashOn = false;
    };
  
    /* ── Scan result ── */
  
    MobileBarcodeScanner.prototype._onScanSuccess = function (decodedText) {
      if (!decodedText) return;
      this._stopCamera();
      this._setStatus('Searching…', '');
      this._resolveBarcode(decodedText);
    };
  
    MobileBarcodeScanner.prototype._skuCache = {};
  
    MobileBarcodeScanner.prototype._resolveBarcode = function (code) {
      var self = this;
      var raw = String(code || '').replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, '').trim();
  
      if (/^https?:\/\//.test(raw)) {
        window.location.href = raw;
        return;
      }
  
      if (!raw || raw.length < 6) {
        self._setStatus('Invalid barcode. Try again.', 'error');
        setTimeout(function () { self._startCamera(); }, 2000);
        return;
      }
  
      var root = this.rootUrl.replace(/\/+$/, '');
      var sku = raw.replace(/[^a-z0-9._-]/gi, '');
  
      function showNotFound() {
        self._hideManual();
        self._setStatus('Product not found. Try again or enter manually.', 'error');
        if (self.manualStatus) self.manualStatus.textContent = 'Product not found.';
        setTimeout(function () { self._startCamera(); }, 3000);
      }
  
      if (self._skuCache[sku]) {
        self._setStatus('Product found. Redirecting…', 'success');
        window.location.href = self._skuCache[sku];
        return;
      }
  
      var suggestUrl = root + '/search/suggest.json?q=' + encodeURIComponent(sku) +
        '&resources[type]=product' +
        '&resources[limit]=10' +
        '&resources[options][fields]=title,product_type,tag,variants.sku,variants.barcode' +
        '&resources[options][unavailable_products]=last';
  
      fetch(suggestUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data && data.resources && data.resources.results &&
            Array.isArray(data.resources.results.products)
            ? data.resources.results.products : [];
          if (!products.length) return null;
  
          var chain = Promise.resolve(null);
          products.forEach(function (p) {
            chain = chain.then(function (found) {
              if (found) return found;
              var handle = p.handle || '';
              if (!handle && p.url) {
                var m = p.url.match(/\/products\/([^/?#]+)/i);
                handle = m ? m[1] : '';
              }
              if (!handle) return null;
  
              return fetch(root + '/products/' + handle + '.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (product) {
                  var variants = product && Array.isArray(product.variants) ? product.variants : [];
                  for (var i = 0; i < variants.length; i++) {
                    var vSku = (variants[i].sku || '').replace(/[^a-z0-9._-]/gi, '');
                    var vBarcode = (variants[i].barcode || '').replace(/[^a-z0-9._-]/gi, '');
                    if ((vSku && vSku === sku) || (vBarcode && vBarcode === sku)) {
                      return root + '/products/' + handle;
                    }
                  }
                  return null;
                })
                .catch(function () { return null; });
            });
          });
          return chain;
        })
        .then(function (productUrl) {
          if (productUrl) {
            self._skuCache[sku] = productUrl;
            self._setStatus('Product found. Redirecting…', 'success');
            if (navigator.vibrate) navigator.vibrate(75);
            window.location.href = productUrl;
          } else {
            showNotFound();
          }
        })
        .catch(function () {
          showNotFound();
        });
    };
  
    /* ── Flash ── */
  
    MobileBarcodeScanner.prototype._toggleFlash = function () {
      if (!this.scanner || !this.scanning) return;
      var self = this;
  
      try {
        if (this.flashOn) {
          this.scanner.applyVideoConstraints({ advanced: [{ torch: false }] })
            .then(function () { self.flashOn = false; })
            .catch(function () {});
        } else {
          this.scanner.applyVideoConstraints({ advanced: [{ torch: true }] })
            .then(function () { self.flashOn = true; })
            .catch(function () { self._setStatus('Flash not available on this device.', 'error'); });
        }
      } catch (e) {
        /* torch not supported */
      }
    };
  
    /* ── Gallery: select → preview → scan ── */
  
    MobileBarcodeScanner.prototype._handleGallerySelect = function (e) {
      var file = e.target && e.target.files && e.target.files[0];
      if (!file) return;
      this._galleryFile = file;
      if (this.galleryImg) {
        this.galleryImg.src = URL.createObjectURL(file);
      }
      this._showGalleryPreview();
      if (this.galleryInput) this.galleryInput.value = '';
    };
  
    MobileBarcodeScanner.prototype._showGalleryPreview = function () {
      if (this.galleryPreview) this.galleryPreview.hidden = false;
      this._resetPinchZoom();
      this._setGalleryHint('Use two fingers to zoom and drag the image.', false);
      if (this.galleryScanBtn) { this.galleryScanBtn.textContent = 'SCAN IMAGE'; this.galleryScanBtn.disabled = false; }
    };
  
    MobileBarcodeScanner.prototype._hideGalleryPreview = function () {
      if (this.galleryPreview) this.galleryPreview.hidden = true;
      this._galleryFile = null;
      if (this.galleryImg) this.galleryImg.src = '';
    };
  
    MobileBarcodeScanner.prototype._setGalleryHint = function (text, isError) {
      if (!this.galleryHint) return;
      this.galleryHint.textContent = text;
      this.galleryHint.classList.toggle('barcode-scanner__gallery-hint--error', !!isError);
    };
  
    MobileBarcodeScanner.prototype._getCroppedCanvas = function () {
      var img = this.galleryImg;
      var vp = this.galleryViewport;
      if (!img || !vp || !img.naturalWidth) return null;
  
      var vpRect = vp.getBoundingClientRect();
      var imgRect = img.getBoundingClientRect();
  
      var visL = Math.max(0, vpRect.left - imgRect.left);
      var visT = Math.max(0, vpRect.top - imgRect.top);
      var visR = Math.min(imgRect.width, vpRect.right - imgRect.left);
      var visB = Math.min(imgRect.height, vpRect.bottom - imgRect.top);
      if (visR <= visL || visB <= visT) return null;
  
      var scX = img.naturalWidth / imgRect.width;
      var scY = img.naturalHeight / imgRect.height;
      var sx = visL * scX, sy = visT * scY;
      var sw = (visR - visL) * scX, sh = (visB - visT) * scY;
  
      var c = document.createElement('canvas');
      c.width = Math.round(sw);
      c.height = Math.round(sh);
      c.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, c.width, c.height);
      return c;
    };
  
    MobileBarcodeScanner.prototype._canvasToFile = function (canvas) {
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) {
          resolve(blob ? new File([blob], 'crop.png', { type: 'image/png' }) : null);
        }, 'image/png');
      });
    };
  
    MobileBarcodeScanner.prototype._scanGalleryImage = function () {
      if (!this._galleryFile) return;
      var self = this;
      var originalFile = this._galleryFile;
  
      var scanBtn = this.galleryScanBtn;
      if (scanBtn) { scanBtn.textContent = 'SCANNING…'; scanBtn.disabled = true; }
      self._setGalleryHint('Scanning image…', false);
  
      function tryNativeDetector(source) {
        if (!window.BarcodeDetector) return Promise.resolve(null);
        return new BarcodeDetector({ formats: [
          'ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128', 'code_39',
          'code_93', 'itf', 'codabar', 'qr_code', 'data_matrix'
        ] }).detect(source)
          .then(function (results) { return results.length > 0 ? results[0].rawValue : null; })
          .catch(function () { return null; });
      }
  
      function tryHtml5Qrcode(file) {
        return loadScript(CDN_HTML5_QRCODE).then(function () {
          var id = 'bs-gallery-reader';
          var el = document.getElementById(id);
          if (!el) {
            el = document.createElement('div');
            el.id = id;
            el.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;';
            document.body.appendChild(el);
          }
          var reader = new Html5Qrcode(id);
          return reader.scanFile(file, false)
            .then(function (d) { reader.clear(); return d; })
            .catch(function () { reader.clear(); return null; });
        }).catch(function () { return null; });
      }
  
      var croppedCanvas = self._getCroppedCanvas();
      var zoomState = self._getZoomState();
      var isZoomed = zoomState.scale > 1;
  
      var croppedFilePromise = (isZoomed && croppedCanvas)
        ? self._canvasToFile(croppedCanvas)
        : Promise.resolve(null);
  
      croppedFilePromise.then(function (croppedFile) {
        var steps = [];
  
        if (isZoomed && croppedCanvas) {
          steps.push(function () { return tryNativeDetector(croppedCanvas); });
        }
        if (isZoomed && croppedFile) {
          steps.push(function () { return tryHtml5Qrcode(croppedFile); });
        }
        steps.push(function () { return tryNativeDetector(self.galleryImg); });
        steps.push(function () { return tryHtml5Qrcode(originalFile); });
  
        var chain = Promise.resolve(null);
        steps.forEach(function (step) {
          chain = chain.then(function (found) {
            if (found) return found;
            return step();
          });
        });
        return chain;
      }).then(function (code) {
        if (code) {
          self._hideGalleryPreview();
          self._onScanSuccess(code);
        } else {
          if (scanBtn) { scanBtn.textContent = 'SCAN IMAGE'; scanBtn.disabled = false; }
          self._setGalleryHint('Could not read barcode. Try zooming closer to the barcode.', true);
        }
      });
    };
  
    /* ── Pinch-to-zoom on gallery preview ── */
  
    MobileBarcodeScanner.prototype._initPinchZoom = function () {
      var vp = this.galleryViewport;
      var img = this.galleryImg;
      if (!vp || !img) return;
  
      var self = this;
      var scale = 1, lastScale = 1;
      var posX = 0, posY = 0, lastPosX = 0, lastPosY = 0;
      var startDist = 0, startX = 0, startY = 0;
      var pinching = false, dragging = false;
  
      function dist(t) {
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
  
      function mid(t) {
        return {
          x: (t[0].clientX + t[1].clientX) / 2,
          y: (t[0].clientY + t[1].clientY) / 2
        };
      }
  
      function applyTransform() {
        img.style.transform = 'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';
      }
  
      self._resetPinchZoom = function () {
        scale = 1; lastScale = 1;
        posX = 0; posY = 0; lastPosX = 0; lastPosY = 0;
        img.style.transform = '';
      };
  
      self._zoomBy = function (delta) {
        scale = Math.min(Math.max(scale + delta, 1), 5);
        lastScale = scale;
        if (scale <= 1) { posX = 0; posY = 0; }
        applyTransform();
      };
  
      self._getZoomState = function () {
        return { scale: scale, posX: posX, posY: posY };
      };
  
      vp.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          e.preventDefault();
          pinching = true;
          startDist = dist(e.touches);
          lastScale = scale;
        } else if (e.touches.length === 1 && scale > 1) {
          dragging = true;
          startX = e.touches[0].clientX - posX;
          startY = e.touches[0].clientY - posY;
        }
      }, { passive: false });
  
      vp.addEventListener('touchmove', function (e) {
        if (pinching && e.touches.length === 2) {
          e.preventDefault();
          var d = dist(e.touches);
          scale = Math.min(Math.max(lastScale * (d / startDist), 1), 5);
          applyTransform();
        } else if (dragging && e.touches.length === 1) {
          e.preventDefault();
          posX = e.touches[0].clientX - startX;
          posY = e.touches[0].clientY - startY;
          applyTransform();
        }
      }, { passive: false });
  
      vp.addEventListener('touchend', function (e) {
        if (e.touches.length < 2) pinching = false;
        if (e.touches.length < 1) dragging = false;
        lastPosX = posX; lastPosY = posY;
        if (scale <= 1) { scale = 1; posX = 0; posY = 0; applyTransform(); }
      });
    };
  
    /* ── Manual entry ── */
  
    MobileBarcodeScanner.prototype._showManual = function () {
      if (this.manualOverlay) this.manualOverlay.hidden = false;
      if (this.manualInput) { this.manualInput.value = ''; }
      if (this.manualStatus) this.manualStatus.textContent = '';
      var self = this;
      setTimeout(function () { if (self.manualInput) self.manualInput.focus(); }, 100);
    };
  
    MobileBarcodeScanner.prototype._hideManual = function () {
      if (this.manualOverlay) this.manualOverlay.hidden = true;
    };
  
    MobileBarcodeScanner.prototype._submitManual = function () {
      var code = this.manualInput ? this.manualInput.value.trim() : '';
      if (!code) return;
  
      if (this.manualStatus) this.manualStatus.textContent = 'Searching…';
      this._stopCamera();
      this._resolveBarcode(code);
    };
  
    /* ── Status ── */
  
    MobileBarcodeScanner.prototype._setStatus = function (text, type) {
      if (this.status) {
        this.status.textContent = text;
        this.status.className = 'barcode-scanner__hint' +
          (type === 'error' ? ' barcode-scanner__hint--error' : '') +
          (type === 'success' ? ' barcode-scanner__hint--success' : '');
      }
      if (this.bottomMsg) {
        if (type === 'error' || type === 'success') {
          this.bottomMsg.textContent = text;
        } else {
          this.bottomMsg.textContent = 'A successful scan will show the results automatically.';
        }
        this.bottomMsg.classList.toggle('barcode-scanner__success-msg--error', type === 'error');
      }
    };
  
    /* ======================================================================
       INIT — move modals to body + expose scanner opener
       ====================================================================== */
  
    var instances = {};
  
    function initModals() {
      document.querySelectorAll('[data-barcode-scanner-modal]').forEach(function (modal) {
        if (instances[modal.id]) return;
  
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
  
        instances[modal.id] = new MobileBarcodeScanner(modal);
      });
    }
  
    function openScanner(controlsId) {
      initModals();
      var instance = instances[controlsId] || instances[Object.keys(instances)[0]];
  
      if (instance) {
        instance.open();
      }
    }
  
    function init() {
      initModals();
      window.SelectedHommeBarcodeScanner = window.SelectedHommeBarcodeScanner || {};
      window.SelectedHommeBarcodeScanner.open = openScanner;
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();


/* ==========================================================================
   SHADOW-ROOT BARCODE ICON TRIGGER
   Opens the existing scanner only when a shadow DOM icon with
   data-icon-scanner="true" is clicked.
   ========================================================================== */
(function () {
  'use strict';

  function getScannerIconFromPath(event) {
    var path = event.composedPath ? event.composedPath() : [];

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (
        node &&
        node.nodeType === 1 &&
        node.matches &&
        node.matches('[data-icon-scanner="true"]')
      ) {
        return node;
      }
    }

    if (event.target && event.target.closest) {
      return event.target.closest('[data-icon-scanner="true"]');
    }

    return null;
  }

  function openExistingBarcodeScanner(event) {
    var scannerIcon = getScannerIconFromPath(event);
    if (!scannerIcon) return;

    var barcodeScanner = window.SelectedHommeBarcodeScanner;
    if (!barcodeScanner || !barcodeScanner.open) return;

    event.preventDefault();
    event.stopPropagation();
    barcodeScanner.open();
  }

  document.addEventListener('click', openExistingBarcodeScanner, true);
})();
  